"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.matchmakerType = exports.executeOnStopWorkflow = exports.isBuiltInLambda = exports.BuiltInLambdaType = void 0;
var BuiltInLambdaType;
(function (BuiltInLambdaType) {
    BuiltInLambdaType["Expression"] = "Expression";
    BuiltInLambdaType["MessageOutput"] = "MessageOutput";
    BuiltInLambdaType["Edge"] = "Edge";
    BuiltInLambdaType["EnterWorkflow"] = "EnterWorkflow";
    BuiltInLambdaType["ExitWorkflow"] = "ExitWorkflow";
    BuiltInLambdaType["Join"] = "Join";
    BuiltInLambdaType["SerializePayload"] = "SerializePayload";
    BuiltInLambdaType["DeserializePayload"] = "DeserializePayload";
    BuiltInLambdaType["Inline"] = "Inline";
})(BuiltInLambdaType = exports.BuiltInLambdaType || (exports.BuiltInLambdaType = {}));
var isBuiltInLambda = function (lambdaType) {
    return !!BuiltInLambdaType[lambdaType];
};
exports.isBuiltInLambda = isBuiltInLambda;
var executeOnStopWorkflow = function (lambdaType) {
    return (exports.isBuiltInLambda(lambdaType) && lambdaType != BuiltInLambdaType.Inline) || lambdaType == exports.matchmakerType;
};
exports.executeOnStopWorkflow = executeOnStopWorkflow;
exports.matchmakerType = 'Matchmaker';
//# sourceMappingURL=lambda-type.js.map